import React, { Component } from 'react';
import { connect } from 'react-redux';

import Undo from '@material-ui/icons/Undo';
import { Table, TableHead, TableBody, TableFooter, TableRow, TableCell, Button, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Aux from '../../hoc/NoParent';
import Spinner from '../../components/UI/Spinner';

import { loadOrderFromServer } from '../../store/actions/index';
import dataFormatter from '../../util/dataFormatter';
import { DescriptionOutlined } from '@material-ui/icons';

const styles = (theme) => {
    return {
        button: {
            margin: theme.spacing(1)
        }
    };
}

class OrderView extends Component {

    componentDidMount() {
        const { token, match } = this.props;

        if (token) {
            this.props.onLoadOrder(match.params.id, token);
        }
    }

    render() {
        const { loading, error, stops, pay, history, classes } = this.props;

        if (loading) return <Spinner />

        if (error) return <div>Error</div>;

        if (!stops) return null;

        let stopsGrid = null;
        let payGrid = <Typography color="error">
            You have not been paid for this load yet.
            Please make sure the load shows completed and that you have turned in your paperwork
        </Typography>;

        if (stops) {
            stopsGrid = (
                <Aux>
                    <Typography variant="h6" align="center">Stops</Typography>
                    <div style={{ overflow: 'auto' }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Event</TableCell>
                                    <TableCell>Company</TableCell>
                                    <TableCell>Location</TableCell>
                                    <TableCell>Appointment</TableCell>
                                    <TableCell>Miles</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {stops.map(stop =>
                                    <TableRow key={stop.StopNumber}>
                                        <TableCell>{stop.StopEventLabel}</TableCell>
                                        <TableCell>{stop.StopName}</TableCell>
                                        <TableCell>{`${stop.StopAddress1 === null ? '' : (stop.StopAddress1 + ' ')}${stop.StopCity}, ${stop.StopState} ${stop.StopZip}`}</TableCell>
                                        <TableCell>{dataFormatter.toDateTime(stop.StopEarliest, "MM/dd/yyyy HH:mm")}</TableCell>
                                        <TableCell align="right">{stop.MilesToStop}</TableCell>
                                        <TableCell>{stop.StopStatus}</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Aux>
            );
        }

        if (pay && pay.length > 0) {
            let i = 0;
            let totalSettlement = 0;
            payGrid = (
                <Aux>
                    <Typography variant="h6" align="center">Pay</Typography>
                    <div style={{ overflow: 'auto' }}>
                        <Table size="small" className="PayGrid">
                            <TableHead>
                                <TableRow className="PayDetail">
                                    <TableCell className="ItemType">Item Type</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Qty</TableCell>
                                    <TableCell className="Rate">Rate</TableCell>
                                    <TableCell>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pay.map(detail => {
                                    totalSettlement += +detail.detail_amount;

                                    return (
                                        <TableRow key={i++} className="PayDetail">
                                            <TableCell className="ItemType">{detail.detail_code_label}</TableCell>
                                            <TableCell>{detail.detail_description}</TableCell>
                                            <TableCell align="right">{dataFormatter.toNumber(detail.detail_quantity, 2)}</TableCell>
                                            <TableCell className="Rate" align="right">{dataFormatter.toMoney(detail.detail_rate)}</TableCell>
                                            <TableCell align="right">{dataFormatter.toMoney(detail.detail_amount)}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TableCell>Total</TableCell>
                                    <TableCell colSpan={4} align="right">{dataFormatter.toMoney(totalSettlement)}</TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </div>
                </Aux>
            )
        }

        return (
            <Aux>
                <div>
                    <Button
                        className={classes.button}
                        onClick={() => history.push('/loads')}
                        size="small"
                        variant="contained"
                        color="primary"
                        aria-label="Back To Loads"
                        title="Back To Loads">
                        <Undo />
                    </Button>
                    { stops && <Button
                        className={classes.button}
                        onClick={() => window.open(`${process.env.PUBLIC_URL}/lite/paperworks/view/${stops[0].OrderNumbers}`, { target: '_blank' })}
                        size="small"
                        variant="contained"
                        color="secondary"
                        aria-label="View paperwork"
                        title="View paperwork">
                        <DescriptionOutlined />
                    </Button> }
                </div>
                {stopsGrid}
                {payGrid}
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.order.loading,
        error: state.order.error,
        stops: state.order.selectedOrderStops,
        pay: state.order.selectedOrderPay,
        token: state.auth.token
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        onLoadOrder: (legNumber, token) => dispatch(loadOrderFromServer(legNumber, token))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrderView));